<template>
	<div id="onediv">
		<div class="head">
			<weitap :shuju="shuju" :Tapchecked="Tapchecked"></weitap>
		</div>
		<form class="bodybox" id='art_form' method='post'>
			<p class="hu_1"><span class="xinzenghuiyuan_1" style="border-color:#8CBB77">&nbsp;会员详情</span></p>
			<el-row style="padding: 10px;background:#f1f1f1 ">
				<el-col :span="6" style="padding-right: 30px;display: flex">
					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 姓名</div>
					<el-input v-model="baobao_name" name="baobao_name" size="middle"></el-input>
				</el-col>

				<el-col :span="6" style="padding-right: 30px;display: flex">

					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 别名</div>
					<el-input name="baobao_name2" v-model="baobao_name2" size="middle"></el-input>

				</el-col>
				<el-col :span="6" style="padding-right: 30px;display: flex">

					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 出生日期</div>
					<el-date-picker name="baobao_birthday" v-model="baobao_birthday" class="shurubox2" format="yyyy-MM-dd"
					 value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
					</el-date-picker>

				</el-col>
				<!--<el-col :span="6" style="padding-right: 30px;display: flex">-->
				<!--<div class="inputlabel">会员卡号</div>-->
				<!--<el-input v-model="kahao" size="middle" name="kahao"></el-input>-->
				<!--</el-col>-->
			</el-row>

			<el-row style="padding: 10px; background:#f1f1f1 ">
				<el-col :span="6" style="padding-right: 30px;display: flex">

					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 性别</div>
					<div style="width: 100%;padding-top: 10px;padding-left: 10px">
						<el-radio v-model="sex" label="男" name="baobao_sex">男</el-radio>
						<el-radio v-model="sex" label="女" name="baobao_sex" style="margin-left: 15px">女</el-radio>
					</div>
				</el-col>
				<el-col :span="6" style="padding-right: 30px;display: flex">

					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 来源</div>
					<el-select v-model="laiyuan" placeholder="请选择" name="laiyuan" style="width: 100%">
						<el-option v-for="item in laiyuans" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>

				</el-col>


				<el-col :span="12" style="display: flex" v-if="laiyuan=='其他'">
					<div class="inputlabel" style="width: 110px">备注</div>
					<textarea name="bz" style="flex: 1;height: 40px; border: 1px solid #dcdfe6;box-sizing: border-box;padding: 2px"></textarea>
				</el-col>

				<el-col :span="6" style="padding-right: 30px;display: flex" v-if="laiyuan=='市场'">
					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 顾问</div>
					<!--<el-select v-model="laiyuan"  placeholder="请选择"   style="width: 100%">-->
					<!--<el-option-->
					<!--v-for="item in laiyuans"-->
					<!--:key="item.value"-->
					<!--:label="item.label"-->
					<!--:value="item.value">-->
					<!--</el-option>-->
					<!--</el-select>-->

					<select name="gw_id" v-model="guwen" id="" class="el-input__inner" style="width: 100%;-webkit-appearance: button;">
						<option :value="gu.user_id" v-for="gu in guwens">{{gu.username}}</option>

					</select>
				</el-col>
				<!--<div class="fflex" style="margin-bottom: 0.2rem;margin-top: 0.1rem" v-if="laiyuan=='其他'">-->
				<!--<div  class="fflex" style="height: 1.3rem;width: 0.7rem;color: #666;font-size: 0.24rem" >备注</div>-->
				<!--<textarea name="bz" style="flex: 1;height: 1.3rem; border: 1px solid #dcdfe6;box-sizing: border-box;padding: 0.2rem">-->

				<!--</textarea>-->
				<!--</div>-->
			</el-row>

			<p class="hu_1"><span class="xinzenghuiyuan_1" style="border-color:#8CBB77">&nbsp;家长联系方式</span></p>
			<!-- <el-row style="padding: 10px;background:#f1f1f1 " v-for="(i,index1) in dijige" :key="index1" :class="'a'+index1"> -->
			<el-row style="padding: 10px;background:#f1f1f1 " v-for="(i,index1) in dijige" :key="index1">
				<el-col :span="6" style="padding-right: 30px;display: flex">
					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 关系</div>
					<el-select v-model="guanxj[index1]" required="required" name="guanxi[]" style="width: 100%" placeholder="关系">
						<el-option v-for="item in guanxs" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-col>

				<el-col :span="6" style="padding-right: 30px;display: flex">
					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 姓名</div>
					<el-input name="name[]" size="middle"></el-input>
				</el-col>

				<el-col :span="6" style="padding-right: 30px;display: flex">
					<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 联系电话</div>
					<el-input name="phone[]" maxlength="11" size="middle"></el-input>
				</el-col>
				<el-col :span="6" style="padding-right: 30px;">
					<div style="height: 40px" class="jiahao" v-if="index1<1">
						<img class="jialx" @click="jialianx" src="/static/qmsj/img/+.png" alt="">
						<img class="jialx" @click="jianlianx(index1)" src="/static/qmsj/img/tixing.png">
					</div>
				</el-col>
			</el-row>

			<p class="hu_1"><span class="xinzenghuiyuan_1" style="border-color:#8CBB77">&nbsp; 家庭住址</span></p>

			<el-row style="padding: 10px;background:#f1f1f1 ">
				<span style="margin-left: 45px;margin-right: 5px;"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle"
					 alt="">地区</span>
				<!--省市区三级联动-->
				<select @change="prov_save" name="coun" v-model="prov_id">
					<option value="">请选择省份</option>
					<option v-for="(item,index) in provList" :value="item.REGION_ID">
						{{item.REGION_NAME}}
					</option>
				</select>
				<select @change="city_save" name="sheng" v-model="city_id">
					<option value="">请选择城市</option>
					<option v-for="(item,index) in cityList" :value="item.REGION_ID">
						{{item.REGION_NAME}}
					</option>
				</select>
				<select name="qu" v-model="county_id">
					<option value="">请选择地区</option>
					<option v-for="(item,index) in countyList" :value="item.REGION_ID">
						{{item.REGION_NAME}}
					</option>
				</select>
				<img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle;margin-left: 30px;" alt=""><span>详细地址</span>
				<el-input style="width: 40%" v-model="xiangx" name="site" placeholder="请输入内容"></el-input>

				<el-col :span="6" style="padding-right: 30px;display: flex">
					<!--<div class="inputlabel"><img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""> 地区</div>-->
					<!--<el-select size="small" v-model="sheng" name="coun" @change="sitechioce" placeholder="请选择" style="width: 2.2rem;margin-right: 0.3rem">-->
					<!--<el-option-->
					<!--v-for="item in shengs"-->
					<!--:key="item.REGION_ID"-->
					<!--:label="item.REGION_NAME"-->
					<!--:value="item.REGION_ID">-->
					<!--</el-option>-->
					<!--</el-select>-->
				</el-col>
				<el-col :span="6" style="padding-right: 30px;display: flex">
					<!--<div class="inputlabel"></div>-->
					<!--<el-select v-model="shi" placeholder="请选择" name="sheng" @change="sitechioce2" style="width: 100%">
                      <el-option
                              v-for="item in shis"
                              :key="item.REGION_ID"
                              :label="item.REGION_NAME"
                              :value="item.REGION_ID">
                      </el-option>
                  </el-select>-->

					<!--<el-select size="small" v-model="shi" name="sheng" @change="sitechioce2" placeholder="请选择" style="width: 2.2rem;margin-right: 0.3rem">-->
					<!--<el-option-->
					<!--v-for="item in shis"-->
					<!--:key="item.REGION_ID"-->
					<!--:label="item.REGION_NAME"-->
					<!--:value="item.REGION_ID">-->
					<!--</el-option>-->
					<!--</el-select>-->
				</el-col>
				<el-col :span="6" style="padding-right: 30px;display: flex">
					<div class="inputlabel"></div>
					<!--<el-select v-model="qu" @change="sitechioce2" name="qu" placeholder="请选择" style="width: 100%">
                      <el-option
                              v-for="item in qus"
                              :key="item.REGION_ID"
                              :label="item.REGION_NAME"
                              :value="item.REGION_ID"
                      >
                      </el-option>
                  </el-select>-->

					<!--<el-select size="small" v-model="qu" @change="sitechioce2" name="qu" placeholder="请选择" style="width: 2.2rem;margin-right: 0.3rem">-->
					<!--<el-option-->
					<!--v-for="item in qus"-->
					<!--:key="item.REGION_ID"-->
					<!--:label="item.REGION_NAME"-->
					<!--:value="item.REGION_ID"-->
					<!--&gt;-->
					<!--</el-option>-->
					<!--</el-select>-->
				</el-col>
			</el-row>

			<!-- <el-row style="padding: 10px;background:#f1f1f1">
				<el-col :span="18" style="padding-right: 30px;display: flex">
					<div class="inputlabel" style="width: 90px">
						<img src="/static/qmsj/img/hongxing.png" style="vertical-align: middle" alt=""><span>详细地址</span>
						<el-input style="width: 50%" v-model="xiangx" name="site" :rows="3" placeholder="请输入内容"></el-input>
					</div>
				</el-col>
			</el-row> -->
			<el-row style="padding: 10px;background:#f1f1f1;">
				<el-col :span="20" style="padding-right: 30px;display: flex;page: 10px;">
					<div class="inputlabel" style="width: 90px">备注</div>
					<el-input v-model="remark" name="beizhu" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>
			<input type="hidden" name="token" id="" value="" v-model="token" />
		</form>

		<div>
			<div class="queBtnbox">
				<input class=" querentij" type="button" @click="tijiao" value="确认添加">
			</div>
		</div>
		<el-dialog title="会员添加" :visible.sync="user_add" width="20%" class="towclass" style="text-align: center;"
		 :before-close="handleClose">
			<div style="padding-top:15px;padding-bottom: 0px">
				<img src="/static/qmsj/img/tanduigou.png" style="width: 32px" alt=""> <span style="font-size: 20px;line-height: 34px">添加成功</span>
			</div>
			<div style="padding-top: 15px;padding-bottom: 15px;border: none">
				<el-button style="border-radius: 15px;background: #FFFFFF;color: #8CBB77;" type="button" @click="jump('huiyuanxin')">继续添加</el-button>
				<el-button type="button" style="border-radius: 15px;background: #8CBB77;color: #FFFFFF;" @click="jumpprint(1)">会员签约</el-button>

			</div>
		</el-dialog>

	</div>
</template>

<script>
	import purBtn from '@/components/btn.vue'
	import weitap from '@/components/weitap'
	export default {
		components: {
			purBtn,
			weitap,
		},
		data() {
			return {
				token: '',
				need_uid: '',
				user_add: false,
				guwens: [],
				baobao_name: '',
				baobao_name2: '',
				kahao: '',
				baobao_birthday: '',
				shuju: [{
						lian: 'huiyuan',
						neir: '会员列表'
					},
					{
						lian: 'huiyuanxin',
						neir: '新增会员'
					},
					{
						lian: 'huiyuanqianxin',
						neir: '签约续约'
					}
				],
				Tapchecked: 1,
				name1: '',
				date1: '',
				sex: '男',
				shis: [],
				guwen: '',
				qus: '',
				shengs: [],
				xiangx: '',
				guanxs: [{
						value: '1',
						label: '爸爸'
					},
					{
						value: '2',
						label: '妈妈'
					},
					{
						value: '3',
						label: '爷爷'
					},
					{
						value: '4',
						label: '奶奶'
					},
					{
						value: '5',
						label: '姥爷'
					},
					{
						value: '6',
						label: '姥姥'
					}

				],
				laiyuans: '',
				guanxj: ['', '', '', '', '', '', ''],
				guanxi: [{
					g: '0'
				}, {
					g: '0'
				}, {
					g: '0'
				}, {
					g: '0'
				}, {
					g: '0'
				}],
				laiyuan: '',
				jiacon: 1,
				//            guanxijai: 1,
				dijige: [
					'0'
				],
				shengm: '',
				sheng: [{
						value: '1',
						label: '河北'
					},
					{
						value: '2',
						label: '河南'
					},
				],
				shim: '',
				shi: [{
						value: '1',
						label: '河北'
					},
					{
						value: '2',
						label: '河南'
					},
				],
				qum: '',
				qu: [{
						value: '1',
						label: '河北'
					},
					{
						value: '2',
						label: '河南'
					},
				],
				qqq: ['1', '2', '3', '4', '5'],
				xiangdz: '',
				//省市区三级联动
				prov_id: '',
				city_id: '',
				county_id: '',
				provList: [],
				cityList: [],
				countyList: [],
				remark:'',//备注
			};
		},
		created() {
			let that = this
			that.token = that.$cookies.get('token');
			//省
			$.ajax({
					url: process.env.apiUrl + 'saas/Qk/sheng',
					type: 'post',
					data: {
						token: that.token
					},
					success: function(data, status) {
						that.provList = data.data
					},
					fail: function(err, status) {
						console.log(err)
					}
				}),
				// 来源下拉
				$.ajax({
					url: process.env.apiUrl + 'saas/index/get_source',
					type: 'post',
					data: {
						token: that.token
					},
					success: function(e) {
						that.laiyuans = e.data
					},
				})
		},
		methods: {
			handleClose() {
				this.user_add = false;
			},
			//省市区三级联动
			prov_save() {
				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/Qk/sel_coun',
					type: 'post',
					data: {
						coun: that.prov_id,
						token: that.token
					},
					success: function(data, status) {
						that.cityList = data.data
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			city_save() {
				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/Qk/sel_coun',
					type: 'post',
					data: {
						coun: that.city_id,
						token: that.token
					},
					success: function(data, status) {
						that.countyList = data.data
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			jumpprint: function(type) {
				let self = this;
				self.$router.push({
					name: 'huiyuanqianxin',
					query: {
						id: self.need_uid,
						type: type //跳转类型 区分从哪里跳转
					}
				})
			},
			jump: function(d) {
				if (d == 'huiyuanxin') {
					location.reload();
				}
				this.$router.push(d)
			},
			jialianx: function(index) {
				var len = this.dijige.length
				if (this.dijige.length < 6) {
					this.dijige.push(this.qqq[len])
				}
			},
			jianlianx: function(index) {
				if(this.dijige.length>1){
					this.dijige.splice(index, 1)
				}
			},
			sitechioce: function() {
				var self = this;
				$.ajax({
					url: process.env.apiUrl + "saas/User/sheng",
					type: "post",
					dataType: 'json',
					data: {
						sheng: self.sheng
					},
					success: function(data) {
						console.log(data)
						self.shis = data
					}
				});

			},
			sitechioce2: function() {
				var self = this;
				$.ajax({
					url: process.env.apiUrl + "saas/User/sheng",
					type: "post",
					dataType: 'json',
					data: {
						sheng: self.shi
					},
					success: function(data) {
						//                    console.log(data)
						self.qus = data
					}
				});
			},
			tijiao: function() {

				if (!this.baobao_name) {
					this.$message.error('请添加会员姓名!')
					return false;
				}
				if (!this.baobao_name2) {
					this.$message.error('请添加会员别名!')
					return false;
				}

				if (!this.baobao_birthday) {
					this.$message.error('请添加会员生日!')
					return false;
				}
				if (!this.laiyuan) {
					this.$message.error('请添加潜客来源!')
					return false;
				}


				let self = this;

				var art_form = new FormData($('#art_form')[0]);

				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/User/add",
					contentType: false,
					processData: false,
					"dataType": "json",
					"data": art_form,
					success: function(data) {
						if (data.status == 1) {
							self.user_add = true;
							self.need_uid = data.uid; //获取当前增加用户ID
							// self.jupm('huiyuanxin');
							self.$message.success('添加成功！')
						} else if (data.status == 3) {
							self.$message.error('请填写家庭住址!')
						} else if (data.status == 4) {
							self.$message.error('请填写家庭关系!')
						} else if (data.status == 5) {
							self.$message.error('手机号格式不正确!')
						} else {
							self.$message.error('添加失败！' + data.msg)
						}

					}
				});
			},

		},
		mounted: function() {
			var self = this;
			self.token = self.$cookies.get('token');
			$.ajax({
				url: process.env.apiUrl + "saas/User/city",
				type: "post",
				dataType: 'json',
				data: {
					token: self.token
				},
				success: function(data) {

					self.shengs = data
				}
			});

			$.ajax({
				url: process.env.apiUrl + "saas/User/guwen",
				type: "post",
				dataType: 'json',
				data: {
					token: self.token
				},
				success: function(data) {
					console.log(data)
					self.guwens = data
				}
			});



		}

	}
</script>

<style scoped>
	* {

		font-size: 14px;
	}

	select {
		height: 35px;
		border-radius: 3px;
		margin-right: 10px;
	}

	.head {
		padding: 10px 45px 0;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		border-bottom: 1px solid #bdb8e0;
	}

	.bodybox {
		padding-left: 45px;
		padding-right: 45px;
	}

	.xinzenghuiyuan_1 {
		width: 100%;
		height: 25px;
		display: block;
		font-size: 16px;
		border-left: 6px solid #8CBB77;
		margin-top: 12px;
		margin-bottom: 12px;
	}

	.inputlabel {
		width: 120px;
		line-height: 40px;
		text-align: right;
		margin-right: 5px;
	}

	.jialx {
		width: 20px;
		height: 20px;
		margin-left: 10px;
		vertical-align: middle;
		cursor: pointer;
	}

	.jiahao {
		display: flex;
		display: -webkit-flex;
		align-items: center;
	}

	.queBtnbox {
		height: 80px;
		display: flex;
		display: -webkit-flex;
		justify-content: center;
		align-items: center;
	}

	.querentij {
		width: 129px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		color: rgb(255, 255, 255);
		display: block;
		font-size: 16px;
		cursor: pointer;
		box-shadow: rgb(248, 222, 199) 0px 5px 10px;
		background: rgb(253, 176, 106);
		margin: 30px auto 0px;
		border-radius: 16px;
		border-width: initial !important;
		border-style: none !important;
		border-color: initial !important;
		border-image: initial !important;
		outline: none;
	}

	#onediv>.twoclass>.el-dialog {
		border-radius: 35px !important;
	}

</style>



// WEBPACK FOOTER //
// src/pages/huiyuan/huiyuanxin.vue